/**
 * Created by tzxn1833 on 2017/4/5.
 */

import axios from 'axios'
import router from '../router'
import store from 'src/store'
import qs from 'qs'

// prefix url
axios.defaults.baseURL = '/apiWb'
// axios.defaults.timeout = 10000

// prevent http cache
axios.defaults.headers.common['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Pragma'] = 'no-cache'

//  'PUT', 'POST', and 'PATCH'
axios.defaults.transformRequest = [function (data, header) {
    if (header['X-JSON']) {
        return JSON.stringify(data)
    }
    return qs.stringify(data)
}]

var cacheData = {}

// request拦截器
axios.interceptors.request.use((config = {}) => {
    config.headers['token'] = store.state.app.token || ''
    // X-on-loading : 自定义属性，约定是以‘X-’开头
    if (!config['X-loadingOff']) {
        store.dispatch('LOADING', true)
    }
    if (config['X-JSON']) {
        config.headers['Content-Type'] = 'application/json'
        config.headers['X-JSON'] = true
    }
    // 如果请求已经存在缓存里，则取消当前请求，读取缓存
    if (config['X-cacheable'] && cacheData[config.url]) {
        let CancelToken = axios.CancelToken
        this.source = CancelToken.source()
        config.cancelToken = this.source.token
        this.source.cancel({
            url: config.url,
            isCache: true
        })
    }
    return config
}, error => {
    store.dispatch('LOADING', false)
    store.commit('MESSAGE_ERROR', '请求出错了！请稍后重试')
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(response => {
    store.dispatch('LOADING', false)
    if (response.config['X-cacheable']) {
        cacheData[response.config.url] = response.data
    }
    let res = response.data
    if (res.status === true || res.status === 'true') {
    // X-showMessage : 自定义属性，约定是以‘X-’开头
        if (response.config['X-showMessage'] && response.config['X-showMessage'] === true) {
            store.commit('MESSAGE_SUCCESS', res.desc || '操作成功')
        }
        return res
    } else {
    // 登录状态处理
        if (res.code === 1 && store.state.user.id) {
            store.commit('USER_SIGN_OUT')
            router.push({
                name: 'login',
                query: {
                    from: router.history.current.fullPath
                }
            })
        } else {
            store.commit('MESSAGE_ERROR', res.desc)
        }
        return Promise.reject(res)
    }
}, error => {
    store.dispatch('LOADING', false)
    // 判断是否缓存
    if (error.message && error.message.isCache) {
        return Promise.resolve(cacheData[error.message.url])
    }
    if (axios.isCancel(error)) {
        console.log('Request canceled, message is: ', error.message)
    } else {
        store.commit('MESSAGE_ERROR', '服务器有点忙！请稍后重试')
    }
    return Promise.reject(error)
})

export default axios


// WEBPACK FOOTER //
// ./src/modules/axios.js